import { inject } from "mobx-react";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import type { Store } from "../../../../client/stores";
import { reverseRoute } from "../../lib/route";
import { Container, MagicLink } from "../../ui";
import { ArrowIcon } from "../icons/ArrowIcon.component";
import "./TrafficTile.style.scss";
import type { BlockFragment } from "../../generated/webapi.g";
import { LocationPinIcon } from "../../components/icons/LocationPinIcon.component";
import classnames from "classnames";
import { ResponsiveImage } from "../../components/ResponsiveImage.component";
import type { SrcSet } from "../../lib/image";
import { RESPONSIVE_IMAGE } from "../../ui/constants";

interface TrafficProps {
    block: BlockFragment;
    store?: Store;
}

export const TrafficTile = inject("store")(({ store, block }: TrafficProps) => {
    if (!store) {
        return null;
    }
    const { site } = store;
    const { t } = useTranslation();
    const url = reverseRoute(site, "traffic") || "#";
    useEffect(() => store.storeBlock({ ...block }));

    const { tags } = block;
    const css = classnames("component-traffic-tile", {
        [`themed-block`]: tags?.includes("display-hints/themed-block"),
    });

    const imgUrl = "https://i.iheart.com/v3/re/new_assets/61c4e860dc4b3e95055c0770";

    const srcset: SrcSet[] = [
        {
            url: `${imgUrl}?ops=gravity(%22center%22),fit(100,70),quality(80)`,
            descriptor: "1x",
        },
        {
            url: `${imgUrl}?ops=gravity(%22center%22),fit(239,169),quality(80)`,
            descriptor: "2x",
        },
    ];

    return (
        <Container className={css} block={false}>
            <section className="traffic-block">
                <div className="tile-container">
                    <MagicLink to={url}>
                        <span className="title">{t("trafficTile")}</span>
                    </MagicLink>
                </div>
                <MagicLink aria-label="Arrow icon" className="icon-arrow" to={url}>
                    <ArrowIcon />
                </MagicLink>
                <div className="local-traffic-map">
                    <MagicLink to={url}>
                        <ResponsiveImage
                            alt={t("local_traffic")}
                            src={imgUrl}
                            srcset={srcset}
                            initialWidth={RESPONSIVE_IMAGE.trafficTileImageWidth}
                            initialHeight={RESPONSIVE_IMAGE.trafficTileImageHeight}
                        />
                        <LocationPinIcon />
                    </MagicLink>
                </div>
            </section>
        </Container>
    );
});

export default TrafficTile;
